import { Tag } from '@bloomays-lib/ui.shared';
import { useTheme } from '@mui/material/styles';
import { BusinessType } from '@bloomays-lib/types.shared';

type TagMissionTypeProps = {
  type: BusinessType;
};

const TagMissionType = ({ type }: TagMissionTypeProps) => {
  const theme = useTheme();
  return (
    <Tag
      text={type}
      aria-label={type}
      backgroundColor={type === BusinessType.IT ? theme.palette.blue[60] : theme.palette.red[60]}
      color={theme.palette.common.white}
    />
  );
};

export default TagMissionType;
